import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  queue: [],
};

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    /**
     * Adds a new feedback message to the queue.
     * Payload: { message, type: 'success' | 'error' | 'warning' | 'info', duration: number }
     */
    showFeedback: (state, action) => {
      const id = Date.now() + Math.random();
      state.queue.push({
        id,
        message: action.payload.message || "Something went wrong",
        type: action.payload.type || "info",
        duration: action.payload.duration || 4000,
      });
    },
    /**
     * Removes a specific feedback message by ID.
     */
    removeFeedback: (state, action) => {
      state.queue = state.queue.filter((f) => f.id !== action.payload);
    },
    /**
     * Clears all pending feedback.
     */
    clearAllFeedback: (state) => {
      state.queue = [];
    },
  },
});

export const { showFeedback, removeFeedback, clearAllFeedback } = feedbackSlice.actions;

export const selectFeedbackQueue = (state) => state.feedback.queue;

export default feedbackSlice.reducer;
